import { atom } from 'jotai'

/**
 * One-shot request to put `text` into the chat composer whose draft bucket is
 * `storageKey` (see useComposerDraftPersistence). The composer consumes and clears it,
 * whether it was already mounted or mounts because of the request.
 */
export interface ComposerPrefillRequest {
  storageKey: string
  text: string
}

export const composerPrefillRequestAtom = atom<ComposerPrefillRequest | null>(null)
